import { ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

interface LoadingButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isProcessing?: boolean;
  loadingText?: string;
  variant?: 'primary' | 'danger';
  fullWidth?: boolean;
}

export default function LoadingButton({
  children,
  isProcessing = false,
  loadingText,
  variant = 'primary',
  fullWidth = false,
  className,
  disabled,
  ...props
}: LoadingButtonProps) {
  // Remove isProcessing from props to avoid DOM warning
  const buttonProps = {
    ...props,
    disabled: isProcessing || disabled,
    className: clsx(
      'relative flex justify-center items-center gap-2 py-2 px-4 border rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200',
      fullWidth && 'w-full',
      variant === 'primary' && 'border-transparent text-white bg-primary hover:bg-primary-dark focus:ring-primary dark:focus:ring-offset-gray-800',
      variant === 'danger' && 'border-transparent text-white bg-red-600 hover:bg-red-700 focus:ring-red-500 dark:focus:ring-offset-gray-800',
      className
    )
  };

  return (
    <button {...buttonProps}>
      {isProcessing && (
        <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      )}
      <span>
        {isProcessing ? loadingText : children}
      </span>
    </button>
  );
}